import { type ComponentPropsWithoutRef, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import type { ErrorMessages, Rules } from '../../config/types';
import Details from './Details';
import ErrorMessage from './ErrorMessage';

type Props = {
  name: string;
  name1: string;
  title: string;
  width?: 'full' | 'three-quarters' | 'two-thirds' | 'one-half' | 'one-third' | 'one-quarter';
  rules?: Rules;
  errorMessages?: ErrorMessages;
  detailsHeading?: string;
  detailsContent?: string;
} & ComponentPropsWithoutRef<'input'>;

const DualInput = (props: Props) => {
  const { name, defaultValue, detailsHeading, detailsContent } = props;
  const { getFieldState, getValues, setValue } = useFormContext();

  useEffect(() => {
    if (getValues(name) === undefined) {
      setValue(name, defaultValue ?? '');
    }
  }, []);
  const { error } = getFieldState(name);

  return (
    <>
      {error && <ErrorMessage error={error} />}
      {detailsHeading && <Details heading={detailsHeading} content={detailsContent} />}
      <br />
      <input
        {...props}
        type={props.type || 'text'}
        className={'govuk-input govuk-!-width-100'}
        inputMode="numeric"
        onFocus={(e) =>
          e.target.addEventListener('wheel', (e) => e.preventDefault(), { passive: false })
        }
      />
    </>
  );
};
DualInput.displayName = 'DualInput';

export default DualInput;
